<template>
  <div class="view-container">
    <PageHeader title="اطلاعات بیماران" :infoLearnUrl="infoLearnUrl" infoTitle="راهنمای اطلاعات بیماران">
      <template #info>
        <p style="line-height:1.9; white-space:pre-line;">
          این قسمت مربوط به اطلاعات پرونده بیماران است.

          جهت اضافه نمودن بیمار جدید بر روی دکمه افزودن کلیک کنید و جهت جستجو ابتدا نام یا نام خانوادگی یا شماره همراه
          یا کد ملی فرد مد نظر را وارد نموده سپس دکمه جستجو را بزنین.

          برای ویرایش اطلاعات بیماران بر روی مداد آبی رنگ، برای حذف بر روی سطل قرمز، برای اضافه کردن فایل های ضمائم بر
          روی ضمیمه نارنجی رنگ و برای ارسال پیامک بر روی آیکون پیام سبز رنگ کلیک نمایید.

          جهت مشاهده فیلم آموزشی این قسمت بر روی لینک زیر کلیک نمایید.
        </p>
      </template>
    </PageHeader>

    <div class="patients-container">
      <div class="sub-header">
        <h2 class="page-title">لیست اطلاعات بیماران</h2>
        <BaseButton class="add" title="جدید" @click="openModal" id="responsive-style" />
      </div>
      <hr class="divider-line" />
      <div class="search">
        <input id="general-search" type="text" v-model="searchQuery"
          placeholder="جستجو بر اساس (نام ، نام خانوادگی ، شماره ملی ، شماره همراه)" />
        <BaseButton title="جستجو" @click="fetchPatients(1)" />
      </div>
      <BaseTable :items="patientsWithAge" :empty-colspan="20" wrapper-class="table-wrapper">
        <template #empty>
          هیچ بیماری ثبت نشده است. برای شروع، روی دکمه "افزودن بیمار" کلیک کنید.
        </template>

        <template #head>
          <tr>
            <th>ردیف</th>
            <th>شماره پرونده</th>
            <th>نام</th>
            <th>نام خانوادگی</th>
            <th>کد ملی</th>
            <th>جنسیت</th>
            <th>تاریخ تولد</th>
            <th>سن(روز/ماه/سال)</th>
            <th>تلفن همراه</th>
            <th>تلفن ثابت</th>
            <th>نوع بیمه</th>
            <th>شماره بیمه</th>
            <th>نام پدر</th>
            <th>نام همسر</th>
            <th>تاریخ مراجعه اولیه</th>
            <th>ش پرونده دستی</th>
            <th>معرف</th>
            <th>شغل</th>
            <th>توضیحات</th>
            <th>عملیات</th>
          </tr>
        </template>

        <template #row="{ item: patient, index }">
          <td data-label="ردیف">
            {{
              toPersianDigits(
                (pagination.current_page - 1) * pagination.per_page +
                index +
                1
              )
            }}
          </td>
          <td data-label="شماره پرونده">
            {{ toPersianDigits(patient.fParno) }}
          </td>
          <td data-label="نام">{{ patient.fTname }}</td>
          <td data-label="نام خانوادگی">{{ patient.fFami }}</td>
          <td data-label="شماره ملی">
            {{ toPersianDigits(patient.pmeli) }}
          </td>
          <td data-label="جنسیت">{{ patient.shSex }}</td>
          <td data-label="تاریخ تولد">
            {{ toPersianDigits((patient.fBrdt)) }}
          </td>
          <td data-label="(روز/ماه/سال)سن">{{ toPersianDigits(patient.fAge) }}</td>
          <td data-label="شماره موبایل">
            {{ toPersianDigits(patient.ptele) }}
          </td>
          <td data-label="شماره ثابت">
            {{ toPersianDigits(patient.fTdesc2) }}
          </td>
          <td data-label="نوع بیمه">{{ patient.fBdesc }}</td>
          <td data-label="شماره بیمه">
            {{ toPersianDigits(patient.fBimehno) }}
          </td>
          <td data-label="نام پدر">{{ patient.fFather }}</td>
          <td data-label="نام همسر">{{ patient.pdesc2 }}</td>
          <td data-label="تاریخ مراجعه اولیه">
            {{
              toPersianDigits(patient.fFirstdt)
            }}
          </td>
          <td data-label="ش پرونده دستی">
            {{ toPersianDigits(patient.fParold) }}
          </td>
          <td data-label="معرف">{{ patient.fMoaref }}</td>
          <td data-label="شغل">{{ patient.fJob }}</td>
          <td data-label="توضیحات">{{ patient.pdesc1 }}</td>
          <td class="actions-cell" data-label="عملیات">
            <button class="action-btn edit" @click="handleEdit(patient)" aria-label="ویرایش"
              @mouseenter.stop="showFloatingTooltip($event, 'ویرایش')" @mouseleave.stop="hideFloatingTooltip()"
              @focus.stop="showFloatingTooltip($event, 'ویرایش')" @blur.stop="hideFloatingTooltip()">
              <img src="/img/edit.svg" alt="ویرایش" />
            </button>
            <button class="action-btn delete" @click="deletePatient(patient.fTauto)" aria-label="حذف"
              @mouseenter.stop="showFloatingTooltip($event, 'حذف')" @mouseleave.stop="hideFloatingTooltip()"
              @focus.stop="showFloatingTooltip($event, 'حذف')" @blur.stop="hideFloatingTooltip()">
              <img src="/img/trash.svg" alt="حذف" />
            </button>
            <button class="action-btn archive" @click="openHistoryModal(patient.fTauto)" aria-label="سوابق"
              @mouseenter.stop="showFloatingTooltip($event, 'سوابق')" @mouseleave.stop="hideFloatingTooltip()"
              @focus.stop="showFloatingTooltip($event, 'سوابق')" @blur.stop="hideFloatingTooltip()">
              <img src="/img/attachment1.svg" alt="سوابق" />
            </button>
            <button class="action-btn sms" @click="sendSMS(patient)" aria-label="ارسال پیامک"
              @mouseenter.stop="showFloatingTooltip($event, 'ارسال پیامک')" @mouseleave.stop="hideFloatingTooltip()"
              @focus.stop="showFloatingTooltip($event, 'ارسال پیامک')" @blur.stop="hideFloatingTooltip()">
              <img src="/img/sms.svg" alt="ارسال پیامک" />
            </button>
          </td>
        </template>
      </BaseTable>

      <!-- Pagination Component -->
      <PaginationPart :pagination="pagination" @page-change="handlePageChange" />
    </div>

    <div v-if="isModalOpen" class="modal-overlay center-modal-overlay">
      <div class="modal-content">
        <div class="sub-header">
          <ModalHeader>
            <template #default>
              <h2 class="page-title"> اطلاعات بیمار </h2>
            </template>
          </ModalHeader>
          <div class="form-actions">
            <BaseButton title="ثبت اطلاعات" form="patient-form" @click="handleSubmit" id="responsive-style"
              variant="primary" />
            <BaseButton title="انصراف" id="responsive-style" @click="closeModal" variant="cancel" />
          </div>
        </div>
        <hr class="divider-line" />
        <PatientForm v-model="patientForm" @submit="handleSubmit" form-id="patient-form" />
      </div>
    </div>
    <div v-if="isModalHistoryOpen" class="modal-overlay center-modal-overlay">
      <div class="modal-content">
        <div class="modal-sub-header">
          <div class="sub-header">
            <ModalHeader>
              <template #default>
                <h2 class="page-title">سوابق بیمار</h2>
              </template>
            </ModalHeader>
            <div class="form-actions">
              <BaseButton title="ثبت اطلاعات" id="responsive-style" @click="handleHistorySubmit" variant="primary" />
              <BaseButton title="انصراف" id="responsive-style" @click="closeHistoryModal" variant="cancel" />
            </div>
          </div>
          <hr class="divider-line" />
        </div>
        <PatientRecords ref="patientRecordsRef" :patient-id="editingPatientId" @data-changed="handleDataChange" />
      </div>
    </div>
  </div>
  <!-- Info is handled by PageHeader -->
  <Teleport to="body">
    <div v-if="floatingTooltip.visible" class="floating-tooltip"
      :style="{ left: floatingTooltip.left + 'px', top: floatingTooltip.top + 'px' }">
      {{ floatingTooltip.text }}
    </div>
  </Teleport>
</template>

<script setup>
import PageHeader from '@/components/PageHeader.vue';
import BaseButton from '@/components/UiCompunents/BaseButton.vue';
import BaseTable from '@/components/UiCompunents/BaseTable.vue';
import { onMounted, ref, reactive, watch } from "vue";
import { useFloatingTooltip } from '@/composables/useFloatingTooltip'
//import DatePicker from "vue3-persian-datetime-picker";
import moment from "jalali-moment";
import { storeToRefs } from "pinia";
import { usePatientsStore } from "@/stores/clinic/patients.js";
import PatientForm from "@/components/patients/PatientForm.vue";
import ModalHeader from '@/components/ModalHeader.vue';
import PatientRecords from "@/components/patients/PatientRecords.vue";
import PaginationPart from "@/components/PaginationPart.vue";
import { useToast } from "vue-toastification";
import { useSettingStore } from "@/stores/clinic/setting";
import { toPersianDigits } from '@/utils/formatters.js';

/**
 * Converts a Gregorian date string (YYYY-MM-DD) to a Jalali string (YYYY/MM/DD).
 */

/**
 * Converts English/Latin digits in a string to Persian digits.
 */
// use centralized formatters

// --- State ---
const isModalOpen = ref(false);
const isModalHistoryOpen = ref(false);
// Info modal state for the header info icon
// Info modal link handled by PageHeader; no local state required

const formMode = ref("add");
const editingPatientId = ref(null);
const showAddModal = ref(false)
const patientRecordsRef = ref(null)
const toast = useToast();
const settingStore = useSettingStore();
const { fetchSetting } = settingStore;
// Info page link
const infoLearnUrl = 'https://www.sinapardazesh.ir/matab-learning-web/';
// --- Store Setup ---
const patientsStore = usePatientsStore();
const { patientsWithAge, pagination, searchQuery, fileSerialCounter } =
  storeToRefs(patientsStore);
const {
  addPatient,
  updatePatient,
  deletePatient,
  fetchPatients,
  setFileSerialStart,
  SendSMS,
  getMaxPersonNumber,
  uploadMultipleFiles
} = patientsStore;

const initialFormState = {
  //hesabTafsili Feild
  fTauto: 0,
  fTcode: '',
  fTname: '',
  fTdesc1: '',
  fTdesc2: '',
  fTtaftype: 0,
  fTnotshow: 0,
  fTuser: '',
  fTtxdate: '',
  fTtxtime: '',
  //personComplete
  pauto: 0,
  pkind: 0,
  pecon: '',
  pmeli: '',
  postn: '',
  pshahr: '',
  pcity: '',
  ppost: '',
  pdesc2: '',
  pdesc3: '',
  pfld1: 0,
  pfld2: 0,
  pfld3: 0,
  fFami: '',
  fParno: 0,
  fJob: '',
  fFirstdt: '',
  fBrdt: '',
  fSex: 0,
  fMoaref: '',
  fNezmno: '',
  fParold: '',
  fFather: '',
  fBimeh: 0,
  fBimehno: '',
  pgroup: 0,
  pcitycode: '',
  pinternal: '',
  pinternal2: '',
  pprsnkind: '',
  pitem1: 0,
  pitem2: 0,
  pitem3: 0,
  pitem4: 0,
  pitem5: 0,
  pitem6: 0,
  pintime: '',
  pottime: '',
  ptimetype: 0,
  pbirthplace: '',
  pissueplace: '',
  paccountno: '',
  psheba: '',
  paccounttype: '',
  pbankname: '',
  pbranchnumb: '',
  pbranchname: '',
  pprsnno: '',
  pidentino: '',
  porgjob: 0,
  pemptype: 0,
  pstartdt: '',
  penddt: '',
  pworkplace: 0,
  pedudoc: 0,
  pmarried: 0,
  pchildno: 0,
  pbimehno: '',
  psrvccond: 0,
  paeleno1: 0,
  paeleno2: 0,
  pmok1: 0,
  pmok2: 0,
  pcardno: '',
  ptele: ''
};

let patientForm = reactive({ ...initialFormState });

// --- WATCHERS ---
// This watch effect belongs in the PARENT component
watch(
  () => patientForm.fTcode,
  (newVal) => {
    if (newVal && newVal !== fileSerialCounter.value) {
      setFileSerialStart(newVal);
    }
  }
);

// --- METHODS Record ---
function openHistoryModal(patientId) {
  debugger
  console.log(patientId);
  // Automatically set the next file serial number in the form
  editingPatientId.value = patientId;
  isModalHistoryOpen.value = true;

  // Disable body scroll when modal is open
  document.body.style.overflow = 'hidden';
}

// Info modal now handled by PageHeader; openInfoModal removed

// closeInfoModal is handled by InfoModal via v-model
async function sendSMS(patient) {
  if (patient.ptele === "" || patient.ptele === undefined || patient.ptele === null) {
    toast.error("شماره موبایل را وارد نمایید")
    return;
  }

  const data = {
    toNumbers: [patient.ptele],
    message: `نام شما با شماره پرونده ${patient.fParno} در سامانه مطب ثبت گرديد.`
  }
  await SendSMS(data)
}

function closeHistoryModal() {
  isModalHistoryOpen.value = false;

  // Re-enable body scroll when modal is closed
  document.body.style.overflow = 'auto';
}

// --- METHODS ---
async function openModal() {
  formMode.value = "add";
  resetForm();
  const maxNumber = ref(0);
  const cashSetting = await fetchSetting();
  if (cashSetting == undefined) {
    toast.error("برای شما تنظیماتی وجود ندارد، لطفا تنظیمات را اعمال نمایید")
    return;
  }
  const printSettings = JSON.parse(cashSetting.printSettings);
  if (printSettings && printSettings.automaticPatientNumber) {
    // گرفتن آخرین شماره از سرور
    maxNumber.value = await getMaxPersonNumber();
  }

  // ست کردن در فرم و شمارنده
  setFileSerialStart(maxNumber.value);

  // مقدار در فرم هم نمایش داده شود
  patientForm.fParno = maxNumber.value;

  // نمایش مدال
  isModalOpen.value = true;
}


function closeModal() {
  isModalOpen.value = false;
}
function resetForm() {
  Object.assign(patientForm, initialFormState);
  patientForm.initialVisitDate = moment().format("jYYYY/jMM/jDD");
}

function getGenderDisplay(genderValue) {
  if (genderValue === 2) return "مرد";
  if (genderValue === 1) return "زن";
  return "ثبت نشده";
}

// SUGGESTION: Made the function async
async function handleSubmit() {
  if (formMode.value === "add") {
    // await the async store action
    await addPatient({ ...patientForm });
  } else {
    // await the async store action
    patientForm.fTauto = editingPatientId.value.toString();
    await updatePatient({ ...patientForm });
  }

  closeModal();
}

function handleEdit(patient) {
  formMode.value = "edit";
  editingPatientId.value = patient.fTauto;

  // ایجاد کپی از داده‌های بیمار
  const patientDataForForm = { ...patient };

  // تبدیل تاریخ‌ها به جلالی
  if (patientDataForForm.birthDate && patientDataForForm.birthDate !== "0000-00-00") {
    patientDataForForm.birthDate = moment(patientDataForForm.birthDate, "YYYY-MM-DD").format("jYYYY/jMM/jDD");
  } else {
    patientDataForForm.birthDate = "";
  }

  if (patientDataForForm.initialVisitDate && patientDataForForm.initialVisitDate !== "0000-00-00") {
    patientDataForForm.initialVisitDate = moment(patientDataForForm.initialVisitDate, "YYYY-MM-DD").format("jYYYY/jMM/jDD");
  } else {
    patientDataForForm.initialVisitDate = "";
  }

  // پر کردن فرم با داده‌های موجود
  Object.assign(patientForm, patientDataForForm);

  // تنظیم شماره پرونده و شمارنده
  // const currentFileSerial = parseInt(patient.fParno || patient.fileSerial || 1);
  // setFileSerialStart(currentFileSerial);
  // patientForm.fTcode = currentFileSerial;

  // نمایش مدال
  isModalOpen.value = true;
}

const openAddModal = () => {
  showAddModal.value = true
}
const refreshRecords = async () => {
  if (patientRecordsRef.value && patientRecordsRef.value.loadRecords) {
    await patientRecordsRef.value.loadRecords(editingPatientId.value)
  }
  showAddModal.value = false;
}
// Pagination handler
function handlePageChange(page) {
  fetchPatients(page);
}

// Load initial data when component is ready

// داده‌های دریافتی از کامپوننت فرزند
const childData = ref({
  patientInfo: {},
  files: [],
  attachments: []
})

// هندل کردن تغییرات داده‌ها از کامپوننت فرزند
const handleDataChange = (data) => {
  childData.value = { ...childData.value, ...data }
}
// تابع ثبت اطلاعات
const handleHistorySubmit = async () => {
  try {
    // دریافت داده‌ها از کامپوننت فرزند
    const submitData = await patientRecordsRef.value.getSubmitData()
    console.log(submitData.patientInfo.doctorId);
    if (submitValidation(submitData)) {
      await submitToBackend(submitData)

      toast.success('اطلاعات با موفقیت ثبت شد')
      closeHistoryModal()
    }
    // اینجا می‌توانید داده‌ها را به backend ارسال کنید

  } catch (error) {
    console.error('خطا در ثبت اطلاعات:', error)
    toast.error('خطا در ثبت اطلاعات')
  }
}
const submitValidation = (submitData) => {
  if (submitData.patientInfo.doctorId === "" ||
    submitData.patientInfo.doctorId === undefined ||
    submitData.patientInfo.doctorId === 0) {
    toast.error("پزشک را وارد نمایید");
    return false;
  }
  if (submitData.files.length <= 0) {
    toast.error("هیچگونه فایلی انتخاب نشده است");
    return false;
  }
  return true;
}
// ارسال به backend
const submitToBackend = async (data) => {
  try {
    const formData = new FormData()

    // اضافه کردن اطلاعات اصلی
    formData.append('FSpauto', editingPatientId.value.toString());
    formData.append('FStype', '1'); // مقدار پیش‌فرض

    // اضافه کردن اطلاعات patientInfo اگر موجود باشد
    if (data.patientInfo) {
      formData.append('FSdocid', data.patientInfo.doctorId);
      formData.append('FSdate', data.patientInfo.visitDate || new Date().toISOString().split('T')[0]);
      formData.append('FSdesc', data.patientInfo.diagnosis || '');
      formData.append('FSsharh', data.patientInfo.doctorName || '');
      formData.append('FStxuser', 'system'); // یا از کاربر جاری بگیرید
    }

    // اضافه کردن فایل‌ها
    let fileCount = 0;
    if (data.files && data.files.length > 0) {
      data.files.forEach((file, index) => {
        if (file instanceof File) {
          formData.append('Files', file, file.name);
          fileCount++;
        } else if (file instanceof Blob) {
          formData.append('Files', file, `file_${index}`);
          fileCount++;
        }
      });
    }

    console.log(`آماده ارسال: ${fileCount} فایل برای بیمار ${editingPatientId.value}`);

    // دیباگ: نمایش تمام محتویات FormData
    // console.log('محتویات FormData:');
    // for (let [key, value] of formData.entries()) {
    //   if (value instanceof File) {
    //     console.log(`${key}: File - ${value.name} (${value.size} bytes)`);
    //   } else {
    //     console.log(`${key}: ${value}`);
    //   }
    // }

    const response = await uploadMultipleFiles(formData);
    return response;

  } catch (error) {
    console.error('خطا در ارسال به سرور:', error);
    throw error;
  }
}


onMounted(async () => {
  fetchPatients(1);
});
const { floatingTooltip, showFloatingTooltip, hideFloatingTooltip } = useFloatingTooltip()

// expose to template
// nothing to do, it's already top-level variables in script setup
</script>
<style scoped>
.view-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}

.header {
  width: 100%;
  /* make header contents layoutable so we can place the svg to the left */
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: var(--text-color-primary);
  padding: 10px;
  margin-bottom: 0;
  border-radius: 20px;
}

.header .header-text {
  /* Keep the exact font/size/style of the original h1 by inheriting all font properties */
  display: inline-block;
  font: inherit;
  color: inherit;
  line-height: inherit;
}

.info-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  vertical-align: middle;
  /* Use margin-right for consistent spacing (requested). */
  margin-right: 4px;
  margin-left: 4px;
  z-index: 2;
  cursor: pointer;
}

.modal-sub-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: var(--background-color);
  gap: 10px;
  /* z-index: 99; */
  padding-top: 20px;
}

.sub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: var(--text-color-secondary);
  width: 100% !important;

  .add {
    display: flex;
    align-items: center;
    padding: 10px 22px;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    background-color: var(--background-color-button);
    color: var(--background-color);

    &:hover {
      background-color: var(--background-color-button-hover);
    }
  }
}

.patients-container {
  direction: rtl;
  padding: 25px;
  background-color: var(--background-color);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 40px;
}

/* The main form container is now a flexbox column */
.patient-form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* Gap between top and bottom sections */
}

/* --- New styles for the top section layout --- */
.top-section {
  display: flex;
  gap: 20px;
  align-items: stretch;
  /* Makes children have equal height */
}

.image-upload-area {
  flex: 1;
  /* Takes up 1 part of the available space */
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed rgba(var(--text-color-secondary-rgb), 0.16);
  border-radius: 8px;
  background-color: var(--background-color-secondary);
}

.image-placeholder {
  text-align: center;
  color: var(--text-color-secondary);
  cursor: pointer;
}

.age-birth-wrapper {
  display: flex;
  gap: 10px;
  /* Adjust the space between the two fields */
  align-items: flex-start;
  /* Aligns items to the top */
}

.birth-date-group {
  flex: 3;
  /* Takes up 3 parts of the space */
  width: 80% !important;
}

.age-group {
  flex: 1;
  /* Takes up 1 part of the space */
  width: 20% !important;
}

.age-group input {
  text-align: center;
}

.image-placeholder span {
  font-size: 48px;
  line-height: 1;
}

.top-form-fields {
  flex: 6;
  /* Takes up 3 parts of the space (wider) */
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

/* --- End of new styles --- */

.bottom-form-fields {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.span-4 {
  grid-column: span 4;
}

.form-group label {
  margin-bottom: 5px;
  color: var(--text-color-thirdly);
  text-align: justify;
}

.required {
  color: var(--background-color-danger);
  margin-right: 4px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 5px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  width: 100%;
  color: var(--text-color-primary);
}

.form-group input,
.form-group select {
  height: 34px;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--text-color-primary);
}

.form-actions {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}

/* .cancel-button {
  padding: 8px 20px;
  background-color: var(--background-color-button2);
  color: var(--text-color-primary);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s;
} */

.cancel-button:hover {
  background-color: var(--background-color-button-hover2);
}

.p-date {
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  overflow: hidden;
  background-color: var(--background-color);
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.p-date :deep(.vpd-container) {
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.12);
  border-radius: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  background-color: var(--background-color);
}

.p-date :deep(.vpd-input-group label) {
  background-color: var(--background-color-button) !important;
}

.p-date :deep(.vpd-input-group input) {
  border: none !important;
  line-height: 32px !important;
  background-color: var(--background-color) !important;
  color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-input-group input::placeholder) {
  color: var(--text-color-secondary) !important;
  opacity: 1;
}

.p-date :deep(.vpd-input-group input:focus) {
  border: 1px solid transparent !important;
}

.p-date :deep(.vpd-icon-btn),
.p-date :deep(button.vpd-icon-btn),
.p-date :deep(.vpd-actions button) {
  background-color: var(--background-color-button) !important;
  color: var(--background-color) !important;
  transition: background-color 0.3s ease !important;
}

.p-date :deep(.vpd-icon-btn svg),
.p-date :deep(button.vpd-icon-btn svg),
.p-date :deep(.vpd-actions button svg),
.p-date :deep(.vpd-icon-btn svg path),
.p-date :deep(button.vpd-icon-btn svg path),
.p-date :deep(.vpd-actions button svg path) {
  fill: var(--background-color) !important;
  color: var(--background-color) !important;
  stroke: var(--background-color) !important;
}

.p-date :deep(.vpd-icon-btn:hover),
.p-date :deep(button.vpd-icon-btn:hover),
.p-date :deep(.vpd-actions button:hover) {
  background-color: var(--background-color-button-hover) !important;
}

/* submit-button styles removed — use BaseButton (variant="primary") where needed */

input#general-search {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  background-color: var(--background-color);
  color: var(--text-color-primary);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.search {
  display: flex;
  gap: 8px;
  align-items: center;
}

.search input#general-search {
  width: auto;
  flex: 1;
}

input#general-search:focus {
  outline: none;
  border-color: var(--text-color-primary);
  box-shadow: 0 0 0 2px rgba(var(--background-color-button-rgb), 0.12);
}

input#general-search::placeholder {
  color: var(--text-color-secondary);
  opacity: 1;
}


.table-wrapper {
  overflow: auto;
  /* Enables both horizontal and vertical scrolling */
  max-height: 70vh;
  /* Set a max height for vertical scrolling */
  border: 1px solid var(--text-color-thirdly) !important;
  border-radius: 10px;
}

/* Scrollbar that respects theme variables */
.table-wrapper {
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
  scrollbar-width: thin;
}

.table-wrapper::-webkit-scrollbar {
  height: 10px;
  width: 10px;
  background: var(--scrollbar-track);
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 8px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--text-color-secondary-rgb), 0.18);
}

.empty-row td {
  text-align: center;
  padding: 40px;
  color: var(--text-color-secondary);
}

.actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  margin: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: calc(0.2vw + 14px);
  height: 100%;
  min-height: 32px;
  width: 100%;

  .edit {
    color: var(--background-color-button);
  }

  .delete {
    color: var(--background-color-danger);
  }

  .archive {
    color: var(--background-color-warning);
  }

  .sms {
    color: var(--background-color-success);
  }
}

/* Inline tooltip CSS removed — floating tooltip used instead */

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(var(--text-color-secondary-rgb), 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow: hidden;
  -webkit-backdrop-filter: saturate(180%) blur(5px) !important;
  backdrop-filter: saturate(180%) blur(5px) !important;
}

.modal-overlay:deep(body) {
  overflow: hidden !important;
}

.modal-content {
  background-color: var(--background-color);
  padding: 20px;
  border-radius: 30px;
  width: 90vw;
  height: 85vh;
  max-width: 90vw;
  max-height: 85vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  direction: rtl;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  box-sizing: border-box;
}

/* Specific styling for the header info modal (do not affect other modals) */
.info-modal-content {
  width: auto;
  max-width: 720px;
  /* reasonable width for the content */
  min-width: 320px;
  height: auto;
  /* allow height to grow with content */
  max-height: 80vh;
  /* cap to prevent overflow */
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.info-modal-content .modal-sub-header {
  padding-top: 8px;
  /* tighten spacing on small info modal */
}

.info-modal-content .modal-body {
  padding: 6px 2px 12px 2px;
  overflow-y: auto;
}

/* Make the body text a bit larger for readability */
.info-modal-content .modal-body p {
  font-size: 18px;
  line-height: 1.9;
  /* keep the existing comfortable spacing */
  text-align: justify;
  direction: rtl;
  text-justify: inter-word;
}

@media (max-width: 480px) {
  .info-modal-content .modal-body p {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .info-modal-content {
    width: 95vw;
    max-width: 95vw;
    max-height: 80vh;
    padding: 12px;
    border-radius: 12px;
  }
}

.modal-close-btn {
  border: none;
  font-size: calc(0.3vw + 12px);
  color: var(--text-color-secondary);
  background-color: transparent;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

@media (max-width: 768px) {
  .patients-container {
    margin-bottom: 0px !important;
  }

  .add {
    padding: 5px 18px !important;
  }

  .modal-overlay {
    align-items: end !important;
  }

  .modal-content {
    max-width: 95vw !important;
    width: 100% !important;
    max-height: 80vh !important;
    padding: 0 10px 10px 10px !important;
    border-radius: 20px 20px 0 0 !important;
    margin: 0 !important;
  }

  .modal-sub-header {
    padding-top: 10px !important;
  }

  .top-section {
    flex-direction: column;
    /* Stack image area on top of fields */
  }

  .top-form-fields,
  .bottom-form-fields {
    grid-template-columns: 1fr;
  }

  .form-group.span-4 {
    grid-column: span 1;
  }

  .image-upload-area {
    min-height: 200px;
  }

  /* .submit-button {
    padding: 5px 16px !important;
  } */

  .table-wrapper {
    overflow: auto;
    /* Enables both horizontal and vertical scrolling */
    min-height: 100vh !important;
    border: none !important;
    border-radius: 0px;
  }

  /* Special styling for the actions cell */
  .actions-cell {
    justify-content: center;
    /* Center the buttons */
  }

  /* Inline tooltip CSS removed - floating tooltip used instead */

  .action-btn {
    align-items: start !important;
  }
}

/* Ensure the info modal overlay remains centered on mobile instead of becoming a bottom sheet */
@media (max-width: 768px) {
  .info-modal-overlay {
    /* Stick the info modal to the bottom on small screens */
    align-items: flex-end !important;
    padding: 0 12px 12px !important;
  }

  .info-modal-content {
    /* behave as a bottom sheet on small screens */
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    border-radius: 12px 12px 0 0 !important;
    padding: 12px !important;
    box-shadow: 0 -6px 30px rgba(0, 0, 0, 0.12) !important;
    transform: none !important;
  }

  /* keep non-info modals centered on mobile inside this component */
  .center-modal-overlay {
    align-items: center !important;
    padding: 12px !important;
  }
}
</style>
